import React from 'react'
import "./Bernabeu.css"
import Navbar from "../../components/navbar/Navbar"
import Header from "../../components/header/Header"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import { faCircleArrowLeft, faCircleArrowRight, faLocationDot } from "@fortawesome/free-solid-svg-icons";
import { faCircleXmark } from "@fortawesome/free-solid-svg-icons";
import {useState} from "react";
import { Map } from "../../components/Map/Map"
import Modal from 'react-modal'
import {AiOutlineCloseCircle} from 'react-icons/ai'
import { loadStripe } from '@stripe/stripe-js'
import { Elements, CardElement, useStripe, useElements} from '@stripe/react-stripe-js'
import axios from 'axios'
import Swal from 'sweetalert2'



const stripePromise = loadStripe('pk_test_51NG6XgB439p1m1xwSpPezHZwMU1w00Eg2K7aK3qf92B9RoXHZcgIfmJfd8DDpjTOYNV7wfDkVGJkYAEN3zbQITU600cyjv6lC1')

const mostrarAlerta=()=>{
    Swal.fire({
            position: 'top-center',
            icon: 'success',
            title: 'Compra exitosa',
            showConfirmButton: false,
            timer: 2000,
    })
    }

const CheckoutForm = () =>{

    const stripe = useStripe();
    const elements = useElements();

    const handleSumbit = async (e) =>{
        e.preventDefault();
    
        const {error, paymentMethod} = await stripe.createPaymentMethod({
            type: 'card',
            card: elements.getElement(CardElement)
        })

        if (!error){
            const { id } = paymentMethod;
            
            const { data }= await axios.post('http://localhost:5000/api/checkout',{
                id,
                amount: 90.000
            })
            console.log(data);

            elements.getElement(CardElement).clear();
    }
    }


    return <form onSubmit={handleSumbit} className='card'>
    <img src="https://res.cloudinary.com/dptohgiiu/image/upload/v1686344023/WhatsApp_Image_2023-06-09_at_3.53.21_PM_wngqvl.jpg" alt="" className='imglog' />
    <div className='Compra'>
        <h3 className='rsu'>Resumen de tu reserva</h3>
    <h3 className='con'>Concepto</h3>
    <p className='Pr'>Reserva de Bernabeu 1 hora cancha futbol 8 hora 3:00 Pm</p>
    <hr />
    <h3 className='val'>Valor Reserva</h3>
    <p className='pre'>120.000</p>
    <img  className='paycan' src="https://res.cloudinary.com/dptohgiiu/image/upload/v1686344484/WhatsApp_Image_2023-06-09_at_4.00.48_PM_lkblfl.jpg" alt="" />
    <p className='pcananchabuy'>Cancha futbol 8</p>
    <h3 className='text-center'>Total a pagar: 120.000</h3>
    <CardElement className='tarjeta'/>  
    <button onClick={()=>mostrarAlerta()} className='buycan' disabled={!stripe}>
        Reservar
    </button>
    </div>
</form>
}


export const Bernabeu = () => {
    const [slideNumber, setSlideNumber, newSlideNumber] = useState (0);
    const [open, setOpen] = useState (false);
    const photos = [
    {
        src: "https://res.cloudinary.com/dptohgiiu/image/upload/v1686076930/C20KiJ-WIAAjDPs_r0c1qt.jpg"
    }, 
    {
        src:"https://res.cloudinary.com/dptohgiiu/image/upload/v1686631200/ber2_ntzdbm.jpg"
    }, 
    {
        src:"https://res.cloudinary.com/dptohgiiu/image/upload/v1686631130/ber1_s0ki3b.jpg"
    }, 
    {
        src:"https://res.cloudinary.com/dptohgiiu/image/upload/v1686077576/283675910_710629946907779_236643014340751240_n_y1wf8x.jpg"
    }, 
    {
        src:"https://res.cloudinary.com/dptohgiiu/image/upload/v1686077040/descarga_vidlbh.jpg"
    }, 
    {
        src:"https://res.cloudinary.com/dptohgiiu/image/upload/v1686077576/284137667_1200227704046195_6002139452955079299_n_twafoc.jpg"
    }, 
   
    ];

    const handleOpen = (i) =>{
        setSlideNumber(i);
        setOpen(true);
    };
    const handleMove = (direction)=>{
        
        let  newSlideNumber;

        if(direction==="l"){
            newSlideNumber = slideNumber === 0 ? 5 : slideNumber-1;
        } else{
            newSlideNumber = slideNumber === 5 ? 0 : slideNumber +1;
        }
        setSlideNumber(newSlideNumber)
    };

    const [modalIsOpen2, setIsOpen2] = React.useState(false);

    function openModal2() {
        setIsOpen2(true);
    }

    function closeModal2() {
        setIsOpen2(false);
    }

    const [modalIsOpen, setIsOpen] = React.useState(false);

    function openModal() {
        setIsOpen(true);
    }

    function closeModal() {
        setIsOpen(false);
    }
    return (
        <div>
            <Navbar/>
            <Header type="list"/>
            <div className="canchaContainer">
                {open && <div className="slider">
                    <FontAwesomeIcon icon={faCircleXmark} className="close" onClick={()=>setOpen(false)}/>
                    <FontAwesomeIcon icon={faCircleArrowLeft} className="arrow" onClick={()=>handleMove("l")}/>
                    <div className="sliderWrapper">
                        <img src={photos[slideNumber].src}  alt="" className="sliderImg" />
                    </div>
                    <FontAwesomeIcon icon={faCircleArrowRight}className="arrow" onClick={()=>handleMove("r")}/>
                </div>}
                <div className="canchaWrapper">
                    <h1 className="canchaTitle">Bernabeu</h1>
                    {/* <button className="reservaAhora">Reservar ahora</button> */}
                    <div className="canchaAddress">
                        <FontAwesomeIcon icon={faLocationDot}/>
                        <span>...</span>
                    </div>
                    <span className="canchaDistance">
                        Excelente localización - 100m del centro
                    </span>
                    <span className="canchaPriceHighlight">
                        si alquila por más de 1 hora en esta cancha se le dara un descuento de un 6% en el proximo alquiler
                    </span>
                    <div className="canchaImages">
                        {photos.map((photo,i)=>(
                            <div className="canchaImgWrapper">
                                <img onClick={()=>handleOpen(i)}src={photo.src} alt="" className="canchaImg" />
                            </div>
                        ))}
                    </div>
                    <div className="canchaDetails">
                        <div className="canchaDetailsTexts">
                            <h1 className="canchaTitle">
                                Bernabeu
                            </h1>
                            <p className="canchaDesc">
                            Canchas Sintéticas Bernabeu, Armenia, Quindío, Colombia está ubicado en Armenia, Quindío, Colombia, cerca de este lugar son: Gimnasio SuperGym (630 m), Centro Deportivo Mormones La Castellana (730 m), Edificio Castellana 9 A N 58 (976 m), Pulso Box armenia (1 km), GIMNASIO EQUILIBRIUM FITNESS (1 km).

                            </p>
                            </div>
                            <div className="canchaDetailsPrice">
                                <h1>Perfecta para jugar!</h1>
                                <span>
                                Cancha con • luces • tienda • gradas de puestos
                                </span>
                                <h2>
                                    $110.000 (1 hora)
                                </h2>
                                <button className="btnrese" onClick={openModal}>Reservar</button>
                            </div>
                            <div className="canchaDetailsPrice">
                                <h1>Perfecta para jugar!</h1>
                                <span>
                                Cancha con • luces • tienda • gradas de puestos
                                </span>
                                <h2>
                                    $110.000 (1 hora)
                                </h2>
                                <button className="btnrese" onClick={openModal2}>Reservar</button>
                            </div>
                        </div>
                    </div>
                    
                </div>
                    <Map/>

                    <Modal isOpen={modalIsOpen2}
                        onRequestClose={closeModal2}>
                            <button className='pointer' onClick={closeModal2}>
                        <AiOutlineCloseCircle></AiOutlineCloseCircle>
                        </button>
                            
                        <Elements stripe={stripePromise}>
                        <CheckoutForm/>
                        </Elements>
                        
                    </Modal>

                    <Modal
                        isOpen={modalIsOpen}
                        onRequestClose={closeModal}
                    ><button className='pointer' onClick={closeModal}>
                        <AiOutlineCloseCircle></AiOutlineCloseCircle>
                        </button>
                        
                        <Elements stripe={stripePromise}>
                        <CheckoutForm/>
                        </Elements>
                        
                    
                        </Modal>
            </div>
    )
}


